var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicatorDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    height: "14px",
    width: "38px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.251,
    height: 1,
    width: 1,
    x: 3,
    y: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.749,
    height: 1,
    width: 1,
    x: 4,
    y: 11
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 5,
    y: 11
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 6,
    y: 11
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 7,
    y: 11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 8,
    y: 11
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 9,
    y: 11
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 10,
    y: 11
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 11,
    y: 11
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 12,
    y: 11
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 13,
    y: 11
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 14,
    y: 11
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 15,
    y: 11
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 16,
    y: 11
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 17,
    y: 11
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 18,
    y: 11
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 19,
    y: 11
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 20,
    y: 11
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 21,
    y: 11
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 22,
    y: 11
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 23,
    y: 11
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 24,
    y: 11
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 25,
    y: 11
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 26,
    y: 11
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 27,
    y: 11
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 28,
    y: 11
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 29,
    y: 11
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 30,
    y: 11
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 31,
    y: 11
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 32,
    y: 11
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.749,
    height: 1,
    width: 1,
    x: 33,
    y: 11
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.251,
    height: 1,
    width: 1,
    x: 34,
    y: 11
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 3,
    y: 12
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 4,
    y: 12
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 5,
    y: 12
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 6,
    y: 12
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 7,
    y: 12
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 8,
    y: 12
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 9,
    y: 12
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 10,
    y: 12
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 11,
    y: 12
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 12,
    y: 12
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 13,
    y: 12
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 14,
    y: 12
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 15,
    y: 12
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 16,
    y: 12
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 17,
    y: 12
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 18,
    y: 12
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 19,
    y: 12
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 20,
    y: 12
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 21,
    y: 12
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 22,
    y: 12
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 23,
    y: 12
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 24,
    y: 12
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 25,
    y: 12
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 26,
    y: 12
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 27,
    y: 12
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 28,
    y: 12
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 29,
    y: 12
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 30,
    y: 12
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 31,
    y: 12
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 32,
    y: 12
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 33,
    y: 12
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 34,
    y: 12
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.251,
    height: 1,
    width: 1,
    x: 35,
    y: 12
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.502,
    height: 1,
    width: 1,
    x: 2,
    y: 13
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 3,
    y: 13
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 4,
    y: 13
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 5,
    y: 13
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 6,
    y: 13
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 7,
    y: 13
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 8,
    y: 13
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 9,
    y: 13
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 10,
    y: 13
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 11,
    y: 13
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 12,
    y: 13
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 13,
    y: 13
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 14,
    y: 13
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 15,
    y: 13
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 16,
    y: 13
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 17,
    y: 13
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 18,
    y: 13
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 19,
    y: 13
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 20,
    y: 13
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 21,
    y: 13
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 22,
    y: 13
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 23,
    y: 13
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 24,
    y: 13
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 25,
    y: 13
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 26,
    y: 13
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 27,
    y: 13
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 28,
    y: 13
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 29,
    y: 13
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 30,
    y: 13
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 31,
    y: 13
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 32,
    y: 13
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 33,
    y: 13
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 1,
    height: 1,
    width: 1,
    x: 34,
    y: 13
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    fill: "#708cfa",
    fillOpacity: 0.251,
    height: 1,
    width: 1,
    x: 35,
    y: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorDarkMode);
export default __webpack_public_path__ + "static/media/indicator_dark_mode.64001068f83aea0061897ea757f0f8b1.svg";
export { ForwardRef as ReactComponent };